import clsx from 'clsx';
import { MotionProps, motion } from 'framer-motion';
import { ComponentPropsWithoutRef, FC } from 'react';

interface TooltipContainerProps extends Pick<ComponentPropsWithoutRef<'div'>, 'className' | 'onClick' | 'style'> {
  motionProps?: MotionProps;
  children?: React.ReactNode;
}

export const TooltipContainer: FC<TooltipContainerProps> = ({ children, motionProps, className, style, onClick }) => {
  const props: Pick<ComponentPropsWithoutRef<'div'>, 'className' | 'onClick' | 'style'> = {
    style: {
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      ...style,
    },
    className: clsx(
      className,
      'shadow-lightModeClassic rounded-md bg-lightMode-snow px-2 py-1',
      'dark:bg-darkMode-gray-dark/[0.95] dark:shadow-classic',
      'hidden sm:block text-white text-xs isolate'
    ),
    onClick,
  };

  return motionProps ? (
    <motion.div {...motionProps} {...props}>
      {children}
    </motion.div>
  ) : (
    <div {...props}>{children}</div>
  );
};
